<template>
    <v-card class="ma-0 pa-3 wrapper">
        <v-container class="pa-0 d-flex align-center justify-space-between gap-8">
            <div class="d-flex align-center gap-2">
                <v-chip
                    label
                    class="product-label"
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.879 2.879C5 3.757 5 5.172 5 8V16C5 18.828 5 20.243 5.879 21.121C6.757 22 8.172 22 11 22H13C15.828 22 17.243 22 18.121 21.121C19 20.243 19 18.828 19 16V8C19 5.172 19 3.757 18.121 2.879C17.243 2 15.828 2 13 2H11C8.172 2 6.757 2 5.879 2.879ZM8.25 17C8.25 16.8011 8.32902 16.6103 8.46967 16.4697C8.61032 16.329 8.80109 16.25 9 16.25H12C12.1989 16.25 12.3897 16.329 12.5303 16.4697C12.671 16.6103 12.75 16.8011 12.75 17C12.75 17.1989 12.671 17.3897 12.5303 17.5303C12.3897 17.671 12.1989 17.75 12 17.75H9C8.80109 17.75 8.61032 17.671 8.46967 17.5303C8.32902 17.3897 8.25 17.1989 8.25 17ZM9 12.25C8.80109 12.25 8.61032 12.329 8.46967 12.4697C8.32902 12.6103 8.25 12.8011 8.25 13C8.25 13.1989 8.32902 13.3897 8.46967 13.5303C8.61032 13.671 8.80109 13.75 9 13.75H15C15.1989 13.75 15.3897 13.671 15.5303 13.5303C15.671 13.3897 15.75 13.1989 15.75 13C15.75 12.8011 15.671 12.6103 15.5303 12.4697C15.3897 12.329 15.1989 12.25 15 12.25H9ZM8.25 9C8.25 8.80109 8.32902 8.61032 8.46967 8.46967C8.61032 8.32902 8.80109 8.25 9 8.25H15C15.1989 8.25 15.3897 8.32902 15.5303 8.46967C15.671 8.61032 15.75 8.80109 15.75 9C15.75 9.19891 15.671 9.38968 15.5303 9.53033C15.3897 9.67098 15.1989 9.75 15 9.75H9C8.80109 9.75 8.61032 9.67098 8.46967 9.53033C8.32902 9.38968 8.25 9.19891 8.25 9Z" fill="#484848"/>
                    <path opacity="0.5" d="M5.235 4.05469C5 4.93769 5 6.17369 5 7.99669V15.9967C5 17.8197 5 19.0547 5.235 19.9387L5 19.9207C4.025 19.8247 3.369 19.6077 2.879 19.1177C2 18.2397 2 16.8247 2 13.9967V9.99669C2 7.16769 2 5.75369 2.879 4.87569C3.369 4.38569 4.025 4.16869 5 4.07269L5.235 4.05469ZM18.765 19.9387C19 19.0547 19 17.8187 19 15.9967V7.99669C19 6.17369 19 4.93769 18.765 4.05469L19 4.07269C19.975 4.16869 20.631 4.38569 21.121 4.87569C22 5.75369 22 7.16669 22 9.99569V13.9957C22 16.8257 22 18.2387 21.121 19.1177C20.631 19.6077 19.975 19.8247 19 19.9207L18.765 19.9387Z" fill="#484848"/>
                    </svg>
                </v-chip>
                <v-card-text class="pa-0 text-body-2">{{ $t('stagnant-products') }}</v-card-text>
            </div>
            <!-- <v-select
                :items="items"
                label="امروز"
                dense
                append-icon="mdi-chevron-down"
                class="mt-0"
                style="width: 0;"
            >
            </v-select> -->
        </v-container>
        <v-card-text class="pa-0 text-caption mt-4 mb-6" style="width: 150px;">
          {{ $t('products that have not been sold for a while.') }}
        </v-card-text>
        <div v-if="$store.getters.getpermission && $store.getters.getpermission.includes('overview')">
          <v-container
            v-if="stagnantProducts != null && stagnantProducts != undefined"
            class="pa-0 d-flex align-center gap-2"
          >
              <v-card-text
                class="pa-0 text-body-1"
              >
              {{ stagnantProducts }}
              </v-card-text>
              <v-card-text class="pa-0 text-caption">{{ $t('product') }}</v-card-text>
          </v-container>
          <v-container
            v-if="stagnantProducts == null && stagnantProducts == undefined"
            class="pa-0"
          >
            <v-card-text class="pa-0 text-caption">
              {{ $t('there is no enough information for showing.') }}
            </v-card-text>
          </v-container>
        </div>
        <div v-else>
          <v-card-text class="pa-0 text-caption">
            {{ $t("you don't have access to this information") }}
          </v-card-text>
        </div>
    </v-card>
</template>

<script>
export default {
  data () {
    return {
      stagnantProducts: null
    }
  },
  methods: {
    fetchList () {
      var app = this
      app.$axios.get(this.$endpoint + 'productsreport', {
        params: {
          report: 'overview',
          dateType: 'year',
          threshold: 0.1
        }
      })
        .then(r => {
          this.stagnantProducts = r.data.productCountWithoutSell
        })
        .catch(e => {
          console.error('Error:', e)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>

<style scoped>
.wrapper {
    background-color: #D9D9D9;
    padding: 10px;
    color: #000;
}
.product-label {
    padding: 0 !important;
    width: 35px;
    height: 33px;
    background: #fff !important;
    display: flex;
    align-items: center;
    justify-content: center;
}
.v-card__text {
    width: auto;
}
::v-deep .v-text-field > .v-input__control > .v-input__slot:before {
    border-color: transparent !important;
}
::v-deep .v-text-field.v-input--dense .v-label {
    top: 0 !important;
}
::v-deep .v-label.v-label {
    font-size: 10px !important;
    color: #000;
}
::v-deep .v-icon.v-icon {
    color: #000;
    font-size: 15px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}
</style>
